import React from 'react';
import { MediaStream } from 'index-types';

/**
 * This context is used to signal if audio, video, share are ready for
 * encoding and decoding. Also it contains Stream, alias of MediaStream of zoom sdk
 */
interface MediaContext {
  audio: {
    encode: boolean;
    decode: boolean;
  };
  video: {
    encode: boolean;
    decode: boolean;
  };
  share: {
    encode: boolean;
    decode: boolean;
  };
  mediaStream: MediaStream | null;
}
export default React.createContext<MediaContext>(null as any);
